import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { createForm, createFormControl, TypedFormArray } from 'osn-shared';
import { PageDetailDialogComponent } from '../page-detail-dialog/page-detail-dialog.component';
import { PageDialogVariant } from '../page-detail-dialog/page-dialog-variant';
import { ContentPageDetailDialogDataViewModel } from './content-page-detail-dialog-data-view.model';
import { ContentPageDetailDialogModalViewModel } from './content-page-detail-dialog-modal-view.model';

@Component({
  selector: 'osn-cxb-content-page-detail-dialog',
  templateUrl: './content-page-detail-dialog.component.html',
  styleUrls: ['./content-page-detail-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentPageDetailDialogComponent extends PageDetailDialogComponent<ContentPageDetailDialogDataViewModel> implements OnInit {
  public isLandingPage = false;

  constructor(@Inject(MAT_DIALOG_DATA) data: ContentPageDetailDialogModalViewModel) {
    super(data);
  }

  protected initForm(metaTagsControl: TypedFormArray<{ key: string; value: string }>) {
    this.formControls = {
      internalName: createFormControl(this.data.data?.internalName ?? '', [Validators.required]),
      tabTitleEnglish: createFormControl(this.data.data?.tabTitleEnglish ?? '', [Validators.required]),
      tabTitleArabic: createFormControl(this.data.data?.tabTitleArabic ?? '', [Validators.required]),
      attachedGenre: createFormControl(this.data.data?.attachedGenre ?? undefined),
      SEOTitleEnglish: createFormControl(this.data.data?.SEOTitleEnglish ?? ''),
      SEOTitleArabic: createFormControl(this.data.data?.SEOTitleArabic ?? ''),
      SEODescriptionEnglish: createFormControl(this.data.data?.SEODescriptionEnglish ?? ''),
      SEODescriptionArabic: createFormControl(this.data.data?.SEODescriptionArabic ?? ''),
      isLandingPage: createFormControl(this.data.data?.isLandingPage ?? false),
      metaTags: metaTagsControl,
    };

    this.form = createForm(this.formControls);

    if (this.data.isGenrePage) {
      this.formControls.attachedGenre.setValidators(Validators.required);
    }

    if (this.data.variant !== PageDialogVariant.NEW) {
      this.formControls.attachedGenre.disable();
    }

    this.isLandingPage = this.data.data?.isLandingPage ?? false;
  }
}
